var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophyBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Background of a trophy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M699.399 526.86L698.685 527.75L698.481 528.872L680.321 628.701L585.675 665.332L584.605 665.746L583.865 666.621L518.286 744.073L418.015 728.57L416.888 728.396L415.813 728.779L320.264 762.916L241.136 699.395L240.247 698.68L239.124 698.476L139.295 680.321L102.663 585.676L102.249 584.607L101.374 583.866L23.9272 518.288L39.4303 418.012L39.6046 416.885L39.2208 415.811L5.08409 320.262L68.6008 241.14L69.3148 240.25L69.519 239.128L87.6795 139.299L182.321 102.667L183.39 102.254L184.13 101.379L249.714 23.9273L349.985 39.435L351.112 39.6094L352.187 39.2255L447.736 5.08421L526.859 68.6053L527.748 69.3195L528.871 69.5236L628.7 87.6791L665.332 182.324L665.746 183.394L666.621 184.134L744.073 249.712L728.57 349.988L728.395 351.115L728.779 352.189L762.916 447.738L699.399 526.86Z",
    fill: "white",
    stroke: "url(#paint0_linear_1090_4509)",
    strokeWidth: 9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1090_4509",
    x1: 474.466,
    y1: 4.54438,
    x2: 474.466,
    y2: 595.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAEFA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#DFB121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyBackground);
export default __webpack_public_path__ + "static/media/trophy_background.bbe449587c77991328d00e1f94f88867.svg";
export { ForwardRef as ReactComponent };